import {event_edit_Api} from 'apis/event'
import {getId, getType} from 'apis/model/base'
import _ from 'lodash'
import React, {useCallback, useContext} from 'react'
import {withProps} from 'recompose'
import OwnerPicker from 'views/AppLocals/custom/OwnerPicker'
import createEditableForm from 'views/AppLocals/factory/createEditableForm'
import {bindQueryParam} from 'views/AppLocals/functions/routerHelper'
import EventContext from '../EventContext'
import useTranslate from "../../../../modules/local/useTranslate";

const formFields = [{name: 'owner'}]

const formSchema = [
    {
        children: [
            {
                name: 'owner',
                component: withProps(({name, form, value, onChange}) => {
                    const {values} = form || {}
                    const {id, type} = values || {}
                    return {
                        id,
                        type,
                        name,
                        onChange,
                        defaultValue: value,
                    }
                })(OwnerPicker),
            },
        ],
    },
]

const EventSettingOwner = () => {
    const t = useTranslate()
    const {event} = useContext(EventContext)

    const [id, type] = [getId(event), getType(event)]

    const onPreSubmit = ({id, type, owner, ...values}) => {
        const [owner_id, owner_type] = [getId(owner), getType(owner)]
        return {
            ...values,
            owner_id,
            owner_type,
        }
    }

    const initialized = useCallback(
        ({owner, ...values}) => ({
            ...values,
            id,
            type,
            owner,
        }),
        [event]
    )

    if (_.isEmpty(event)) return null

    return createEditableForm(
        formFields,
        formSchema
    )({
        item: event,
        query: bindQueryParam({
            id,
        }),
        onPreSubmit,
        initialized,
        apiInfo: event_edit_Api,
        validationSchema: undefined,
        Header:() => (
            <div className="flex flex-col">
                <h2 className="font-bold text-xl text-gray-800 tracking-wide">
                    {t('owner')}
                </h2>
                <div className="my-1 w-20 h-1 rounded-full bg-gray-400"/>
            </div>
        )
    })
}

export default EventSettingOwner
